import { Action } from '@ngrx/store';

export enum ResetAppCacheStoreActionTypes {
  ClearAllStorageAndReload = 'ClearAllStorageAndReload',
  NoResetAppCacheAction = 'NoResetAppCacheAction',
}

export class ClearAllStorageAndReload implements Action {
  readonly type = ResetAppCacheStoreActionTypes.ClearAllStorageAndReload;
  constructor() {}
}

export class NoResetAppCacheAction implements Action {
  readonly type = ResetAppCacheStoreActionTypes.NoResetAppCacheAction;
  constructor() {}
}

export type TResetAppCacheStoreActions = ClearAllStorageAndReload | NoResetAppCacheAction;
